import { useEffect, useState } from "react";
import { MapPin, Plus, Trash2 } from "lucide-react";
import { api, errorMessage } from "../lib/api";

const EMPTY = { name: "", lat: "", lon: "" };

export const AdminCities = ({ onChanged }) => {
  const [cities, setCities] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => { api.get("/admin/cities").then((r) => setCities(r.data)).catch((e) => setError(errorMessage(e))); };
  useEffect(load, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/admin/cities", { name: form.name, lat: Number(form.lat), lon: Number(form.lon) });
      setForm(EMPTY);
      load();
      onChanged?.();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (c) => {
    if (!window.confirm(`Supprimer ${c.name} ?`)) return;
    setError("");
    try {
      await api.delete(`/admin/cities/${encodeURIComponent(c.name)}`);
      load();
      onChanged?.();
    } catch (err) {
      setError(errorMessage(err));
    }
  };

  return (
    <section className="mt-10" data-testid="admin-cities">
      <h2 className="h-display text-3xl">Villes <span className="text-rox-orange">françaises</span></h2>
      <p className="mt-2 text-sm text-rox-off/75">Les coordonnées servent au calcul de distance dans le matching. Astuce : Google Maps → clic droit sur la ville → copier latitude, longitude.</p>
      <form onSubmit={submit} className="panel mt-4 space-y-3 p-4" data-testid="city-form">
        <label className="block">
          <span className="mb-2 block text-sm font-medium">Nom de la ville</span>
          <input data-testid="city-name-input" className="field" placeholder="Dijon" value={form.name} onChange={set("name")} required maxLength={60} />
        </label>
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <span className="mb-2 block text-sm font-medium">Latitude</span>
            <input data-testid="city-lat-input" className="field" type="number" step="0.0001" min={41} max={51.5} placeholder="47.3220" value={form.lat} onChange={set("lat")} required />
          </label>
          <label className="block">
            <span className="mb-2 block text-sm font-medium">Longitude</span>
            <input data-testid="city-lon-input" className="field" type="number" step="0.0001" min={-5.5} max={10} placeholder="5.0415" value={form.lon} onChange={set("lon")} required />
          </label>
        </div>
        {error && <p data-testid="admin-city-error" className="text-sm text-rox-orange">{error}</p>}
        <button data-testid="city-form-submit" className="btn-primary py-3 text-base" disabled={busy}><Plus size={18} /> Ajouter la ville</button>
      </form>
      <div className="mt-4 grid grid-cols-2 gap-2" data-testid="admin-cities-list">
        {cities?.map((c) => (
          <div key={c.name} data-testid={`admin-city-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="panel flex items-center gap-2 p-3">
            <MapPin size={14} className="shrink-0 text-rox-orange" />
            <div className="min-w-0 flex-1">
              <p className="truncate font-display text-base uppercase">{c.name}</p>
              <p className="text-[11px] text-rox-muted">{c.athletes} athlète{c.athletes > 1 ? "s" : ""}</p>
            </div>
            <button onClick={() => remove(c)} data-testid={`admin-city-delete-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-rox-muted hover:text-rox-orange" aria-label="Supprimer"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </section>
  );
};
